import { Identifiable, List } from "@planzone/dto";

function isSame(first: Identifiable<List>, second: Identifiable<List>) {
  return first.uuid === second.uuid;
}

export { isSame };
